import React, { FC } from "react";
import { Trans, useTranslation } from "react-i18next";

import { Stack } from "@mui/material";

import GradientDialog from "@/components/Dialog";
import { PrimaryBtn } from "@/pages/HomePage/components/Hero/styles";
import { colors, fonts, fontSizes } from "@/styles/design-system";

interface IDialog {
  open: boolean;
  handleClose: () => void;
}

const Dialog: FC<IDialog> = ({ open, handleClose }) => {
  const { t } = useTranslation("homePage", { keyPrefix: "newsletter.dialog" });
  return (
    <GradientDialog open={open} handleClose={handleClose}>
      <Stack spacing="40px" height="100%" width="100%" justifyContent="center" alignItems="center">
        <Stack sx={{ gap: "16px" }} justifyContent="center" alignItems="center">
          <h2 style={{
            fontFamily: fonts.heading,
            fontSize: "2rem",
            fontWeight: 400,
            lineHeight: 1.2,
            color: colors.text.heading,
            margin: 0,
            textAlign: "center",
          }}>
            {t("mainText")}
          </h2>
          <p style={{
            fontFamily: fonts.body,
            fontSize: fontSizes.body,
            fontWeight: 400,
            lineHeight: 1.6,
            color: colors.text.body,
            margin: 0,
            textAlign: "center",
          }}>
            <Trans t={t} i18nKey="description" />
          </p>
        </Stack>

        <PrimaryBtn onClick={handleClose}>
          {t("buttonText")}
        </PrimaryBtn>
      </Stack>
    </GradientDialog>
  );
};

export default Dialog;
